import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface PageEvent {
    pageIndex: number;
    pageSize: number;
    length: number;
}

@Component({
    selector: 'app-pagination',
    standalone: false,
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
    @Input() totalItems: number = 0;
    @Input() pageSize: number = 15;
    @Input() pageIndex: number = 0;
    @Input() pageSizeOptions: number[] = [10, 15, 25, 50];
    @Input() showFirstLastButtons: boolean = true;

    @Output() pageChange = new EventEmitter<PageEvent>();

    // PrimeNG Paginator uses 'first' (index of first record) instead of 'pageIndex'
    get first(): number {
        return this.pageIndex * this.pageSize;
    }

    onPageChange(event: any): void {
        this.pageIndex = event.page;
        this.pageSize = event.rows;
        this.pageChange.emit({
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.totalItems
        });
    }
}
